module.exports = __webpack_public_path__ + "static/media/estilosos_feminino_sapatos.8a78c71d.jpg";